import { CaseCustomer, LawsuitAppealIncident, Stakeholder } from "@customTypes/responses/lawsuit";

export const isAppealIncident = (any: unknown): any is LawsuitAppealIncident => {
  return (any as LawsuitAppealIncident).lawsuit !== undefined;
};

export const isStakeholder = (object: Stakeholder | CaseCustomer): object is Stakeholder => {
  return (object as Stakeholder).contactId !== undefined;
};
